<template>
  <b-modal id="identity-detail" ref="modal" size="lg" title="Detail" @reset="" @show="setData" >
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">ID Type</label>
                <div class="col-md-8 mb-3">
                 {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Register Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.registered_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.registered_number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_from}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{ (detail.status ==1 ? 'Active':'Non Active')}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  {{ (detail.is_default ==1 ? 'Yes':'No')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="okHandle"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BForm, BModal} from "bootstrap-vue";

export default {
  name: "IdentityDetailModal",
  components:{
    BForm,
    BModal
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{}
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null ){
          this.detail = this.data
        }
      }, 100)

    },
    okHandle(){
      this.$parent.data = null
      this.$refs.modal.hide()
    },
    resetModal() {
      this.$parent.data = null
    }
  }
}
</script>